// extracted by mini-css-extract-plugin
export default {"accordName":"AccordionBlock_accordName__sitXS","arrowAccord":"AccordionBlock_arrowAccord__kcRxK"};